import { getVendorInvoiceDetailsByInvoiceId } from "../Vendor/VendorListService";
import * as constants from "../../../../../constants";
import { setCreateNewInvoice } from "../../../../../store/ProjectInvoices/newProjectInvoiceSlice";
import toast from "react-hot-toast";
import { getProjecInvoiceApprover } from "./ProjectInvoiceService";
import { getDocumentsById } from "../../Document/DocumentServices";
import { notifyUser } from "../../../Utils/notifyUser";

const sourceList = [
  { id: 1, name: 'Check', value: 'Check' },
  { id: 2, name: 'Wire Transfer', value: 'WireTransfer' },
  { id: 3, name: 'ACH', value: 'ACH' }
];
const formatToCurrency = (num: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(num);
export async function getInvoiceDetailsAndNavigate(
  invoiceId: number,
  clientId: number,
  dispatch: any,
  navigate: any
) {
  try {
    const invRes = await getVendorInvoiceDetailsByInvoiceId(invoiceId, clientId);
    if (invRes?.status === constants.STATUS_CODES.SUCCESS) {
      const invDetails = invRes?.data?.data;
      // Fetch approvers
      const approverList = await fetchInvoiceApprovers(clientId);
      // Initialize name values
      let projectManagerValue = "";
      let businessManagerValue = "";
      let projectApproverValue = "";
      let projectManagerMailId = "";
      let businessMangerMailId = "";
      let projectApproverMailId = "";
      // Loop through approvers and match users 
      invDetails?.invoiceWfApprover.forEach((approver: any) => {
        const user = approverList.find((u: { mailId: any; }) => u.mailId === approver.approverId);
        if (user) {
          const fullName = `${user.firstName || ""} ${user.lastName || "N/A"}`;
          const approverMailId = user?.mailId;
          switch (approver.approverType) {
            case "Project Manager":
              projectManagerValue = fullName;
              projectManagerMailId = approverMailId;
              break;
            case "Business Manager":
              businessManagerValue = fullName;
              businessMangerMailId = approverMailId;
              break;
            case "Project Approver":
              projectApproverValue = fullName;
              projectApproverMailId = approverMailId;
              break;
            default:
              break;
          }
        }
      });
      // Process notificationList to create ccListValue
      const ccListValue = (invDetails?.notificationList || "")
        .split(";")
        .filter((email: string) => email?.trim() !== "")
        .map((email: string) => {
          const approver = approverList.find(
            (user: any) => user.mailId?.toLowerCase() === email.toLowerCase()
          );
          return {
            name: approver ? `${approver.firstName || ""} ${approver.lastName || ""}`.trim() : "",
            mailId: email.trim()
          };
        });

      const invoiceAmountRaw = invDetails?.invoiceTransactionHistory?.[0]?.principalPayment + invDetails?.subsidyAmount;
      const confirmInvoiceAmountRaw = invDetails?.invoiceTransactionHistory?.[0]?.principalPayment + invDetails?.subsidyAmount;
      const maskedInvoiceAmount = invoiceAmountRaw ? '*'.repeat(invoiceAmountRaw.toString().length) : '';
      const maskedConfirmInvoiceAmount = confirmInvoiceAmountRaw ? '*'.repeat(confirmInvoiceAmountRaw.toString().length) : '';
      const matchedPaymentMethod = sourceList.find(
        (method) => method.value === invDetails?.paymentMethod
      ) || null;

      const isInitialApprover = invDetails?.pmAvailable === 1 ? true : false;
      const invoiceApprover = invDetails?.invoiceWfApprover;
      const invoiceTransactionHistory = invDetails?.invoiceTransactionHistory;
      const documentFiles = await getInvoiceDocuments(invDetails?.invoiceId) ?? [];
      const selectedInvoiceFiles = documentFiles.map((doc: any) => {
        const { documentName, ...rest } = doc;
        return {
          documentName: documentName, // rename key
          ...rest
        };
      });

      dispatch(setCreateNewInvoice({
        invoiceId: invDetails?.invoiceId,
        siteName: invDetails?.participantName,
        vendor: invDetails?.vendorName,
        projectNumber: invDetails?.projectNumber,
        participantId: invDetails?.participantId,
        vendorNumber: invDetails?.vendorNumber,
        descriptionValue: invDetails?.description,
        invoiceNumberValue: invDetails?.invoiceNumber,
        confirmInvoiceNumberValue: invDetails?.invoiceNumber,
        subsidyAmount: invDetails?.subsidyAmount,
        invoiceDate: invDetails?.invoiceDate,
        dueDate: invDetails?.dueDate,
        totalAmount: invDetails?.invoiceTransactionHistory[0]?.balance,
        sourceSystem: invDetails?.sourceSystem,
        fee: invDetails?.processingFee,
        invoiceAmountRaw,
        confirmInvoiceAmountRaw,
        maskedInvoiceAmount,
        maskedConfirmInvoiceAmount,
        isInitialApprover,
        invoiceApprover,
        invoiceTransactionHistory,
        paymentMethod: matchedPaymentMethod,
        projectManagerValue,
        businessManagerValue,
        projectApproverValue,
        version: invDetails?.version,
        notificationList: invDetails?.notificationList,
        wfJsonFileName: invDetails?.wfJsonFileName,
        selectedInvoiceFiles,
        ccListValue,
        projectManagerMailId,
        businessMangerMailId,
        projectApproverMailId,
        parentInvoiceNumber: invDetails?.parentInvoiceNumber,
        clientId: invDetails?.clientId,
        paBaComments: invDetails?.paBaComments,
        parentInvoiceId: invDetails?.parentInvoiceId,
        calculatedFeeAmount: formatToCurrency(invDetails?.invoiceTransactionHistory[0]?.feePayment)
      }));

      navigate("/invReviewAndSubmit");
    } else {
      notifyUser(invRes?.error ?? "An error occurred while fetching the invoice data", "error", "Invoice");
    }
  } catch (error: any) {
    notifyUser(error.response.data.message ?? "Unexpected error occurred", "error", "Invoice");
  }
}

export async function fetchInvoiceApprovers(clientId: number) {
  try {
    const response = await getProjecInvoiceApprover(clientId);
    if (response?.status === constants.STATUS_CODES.SUCCESS) {
      return response.data?.data ?? [];
    } else {
      console.error('Failed to fetch invoice approvers');
      return [];
    }
  } catch (err) {
    console.error("Error in fetchInvoiceApprovers:", err);
    return [];
  }
}


export async function getInvoiceDocuments(invoiceId: number) {
  try {
    const response = await getDocumentsById(invoiceId, "Invoice", constants.IS_ACTIVE_YES);
    if (response.status === constants.STATUS_CODES.SUCCESS && response) {
      return response.data.data ?? [];
    }
  } catch (error: any) {
    if (error.status === constants.STATUS_CODES.NOT_FOUND) {
      return [];
    } else {
      notifyUser(error.response.data.message, "error", "Invoice");
      return [];
    }
  }
}